import * as React from 'react';

const ElectronicsBadgeMultichrome64 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 64 64", width: 64, height: 64, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1EAE1",
    d: "M64 32c0 17.672-14.327 32-32 32C14.328 64 0 49.672 0 32S14.328 0 32 0s32 14.327 32 32"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M38.723 17.27a3 3 0 0 1-2.12-.877l-2.51-2.51a3 3 0 0 0-4.24 0l-2.509 2.51a3 3 0 0 1-2.12.878h-4.562a3 3 0 0 0-2.999 3v4.558c0 .796-.316 1.56-.879 2.123l-2.931 2.93a3 3 0 0 0 0 4.246l2.931 2.931c.563.563.88 1.327.88 2.123v3.722a3 3 0 0 0 2.998 3h3.727c.795 0 1.558.317 2.12.88l3.345 3.343a3 3 0 0 0 4.24 0l3.344-3.344a3 3 0 0 1 2.12-.878h3.727a3 3 0 0 0 3-3v-3.723a3 3 0 0 1 .878-2.123l2.931-2.93a3 3 0 0 0 0-4.246l-2.93-2.931a3 3 0 0 1-.88-2.123v-4.557a3 3 0 0 0-2.999-3.001z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#fff",
    d: "M26.902 25.547c-.527-.644-1.49-.743-2.039-.118A9.46 9.46 0 0 0 22.5 31.7a9.5 9.5 0 0 0 19 0 9.46 9.46 0 0 0-2.363-6.27c-.55-.625-1.512-.526-2.04.118-.522.638-.414 1.57.085 2.227a6.5 6.5 0 1 1-10.363 0c.498-.657.605-1.589.083-2.227Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#fff",
    d: "M32 22.2a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 1 1-3 0v-6a1.5 1.5 0 0 1 1.5-1.5"
  }
));
ElectronicsBadgeMultichrome64.Size = 64;
ElectronicsBadgeMultichrome64.Title = "ElectronicsBadgeMultichrome";

export { ElectronicsBadgeMultichrome64 as default };
